module.exports = __webpack_public_path__ + "static/media/quiz-hint-3-es.79c919d8.vtt";